import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, Button, message, Spin, InputNumber, Select } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { LoginContext } from '../../../../context/loginContext';
import LocalidadesDrawer from '../../../components/localidades-drawer.js';

const CSucursalEmpresa = () => {
    const { user } = useContext(LoginContext);
    const [form] = Form.useForm();
    const { id } = useParams(); // si existe, estamos editando
    const [loading, setLoading] = useState(!!id);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const navigate = useNavigate();


    const fetchSucursal = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/sucursal/${id}`, {
                headers: { Authorization: `Bearer ${user.token}` }
            });

            if (!res.ok) throw new Error('Error al obtener la sucursal');

            const data = await res.json();
            if (data.suc_localidad) {
                setSelectedLocation({
                    id: data.loc_id,
                    nombre: data.loc_nombre
                });
            }
            form.setFieldsValue(data);
        } catch (err) {
            message.error('Error al cargar la sucursal');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) fetchSucursal();
    }, [id]);

    const onFinish = async (values) => {
        try {
            const method = id ? 'PUT' : 'POST';
            const endpoint = id
                ? `${process.env.REACT_APP_API_URL}/sucursal/${id}`
                : `${process.env.REACT_APP_API_URL}/sucursal`;

            if (selectedLocation) {
                values.suc_localidad = selectedLocation.id;
            }

            if (!id) {
                values.suc_empresa = user.emp_id;
            }

            const res = await fetch(endpoint, {
                method,
                headers: {
                    'Authorization': `Bearer ${user.token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(values),
            });

            if (!res.ok) throw new Error('Error al guardar la sucursal');

            message.success(id ? 'Sucursal actualizada' : 'Sucursal creada');
            navigate('/lista-sucursal-empresa');
        } catch (err) {
            message.error('Error al guardar la sucursal');
        }
    };

    // Abrir el drawer para seleccionar localidad
    const openLocationDrawer = () => {
        setDrawerVisible(true);
    };

    // Manejar la selección de localidad desde el drawer
    const handleLocationSelect = (location) => {
        setSelectedLocation(location);
        form.setFieldsValue({ loc_nombre: location.nombre });
    };

    if (loading) {
        return <Spin style={{ marginTop: '5rem' }} />;
    }

    return (
        <div style={{ maxWidth: 600, margin: '2rem auto' }}>
            <h2 style={{ textAlign: 'center' }}>{id ? 'Editar' : 'Nueva'} Sucursal</h2>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    label="Nombre"
                    name="suc_nombre"
                    rules={[{ required: true, message: 'Ingrese el nombre' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Dirección"
                    name="suc_direccion"
                    rules={[{ required: true, message: 'Ingrese la dirección' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Localidad"
                    name="loc_nombre"
                    rules={[{ required: true, message: 'Por favor seleccione una localidad' }]}
                >
                    <Input
                        readOnly
                        onClick={openLocationDrawer}
                        value={selectedLocation?.nombre || ''}
                        style={{ cursor: 'pointer' }}
                        placeholder="Haga clic para seleccionar localidad"
                    />
                </Form.Item>

                <Form.Item
                    label="Teléfono"
                    name="suc_telefono"
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Mínimo de Compra"
                    name="suc_mincompra"
                    tooltip="Monto mínimo requerido para realizar un pedido"
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        min={0}
                        step={0.01}
                        precision={2}
                        formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    />
                </Form.Item>

                <Form.Item
                    label="Costo de Envío"
                    name="suc_costoenvio"
                    tooltip="Costo por envío a esta sucursal"
                >
                    <InputNumber
                        style={{ width: '100%' }}
                        min={0}
                        step={0.01}
                        precision={2}
                        formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    />
                </Form.Item>

                <Form.Item
                    label="Horario de Envío - Desde"
                    name="suc_horarioenviod"
                    rules={[{ required: true, message: 'Seleccione el horario desde' }]}
                >
                    <Input type="time"/>
                </Form.Item>

                <Form.Item
                    label="Horario de Envío - Hasta"
                    name="suc_horarioenvioh"
                    rules={[{ required: true, message: 'Seleccione el horario hasta' }]}
                >
                    <Input type="time"/>
                </Form.Item>


                <Form.Item style={{ textAlign: 'center' }}>
                    <Button type="primary" htmlType="submit">
                        Guardar
                    </Button>
                    <Button
                        style={{ marginLeft: 8 }}
                        onClick={() => navigate('/lista-sucursal-empresa')}
                    >
                        Cancelar
                    </Button>
                </Form.Item>
                <LocalidadesDrawer
                    open={drawerVisible}
                    onClose={() => setDrawerVisible(false)}
                    onSelectLocation={handleLocationSelect}
                    initialLocationId={selectedLocation?.id}
                />
            </Form>
        </div>
    );
};

export default CSucursalEmpresa;